import { slideDown, slideUp, slideStop, isVisible } from "slide-anim";
import { section } from "@/glow";
import { listen, qsa, qs } from "@fluorescent/dom";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  itemTrigger: ".collapsible-row-list-item__trigger",
};

section("collapsible-row-list", {
  onLoad() {
    this.items = qsa(selectors.itemTrigger, this.container);
    this.clickHandlers = listen(this.items, "click", e => {
      e.preventDefault();
      const { parentNode: group, nextElementSibling: content } =
        e.currentTarget;

      if (isVisible(content)) {
        this._close(e.currentTarget, group, content);
      } else {
        this._open(e.currentTarget, group, content);
      }
    });

    if (shouldAnimate(this.container)) {
      this.animateCollapsibleRowList = animateStandard(
        this.container
      );
    }
  },

  _open(label, group, content) {
    slideStop(content);
    slideDown(content);
    group.setAttribute("data-open", true);
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
  },

  _close(label, group, content) {
    slideStop(content);
    slideUp(content);
    group.setAttribute("data-open", false);
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  },

  onBlockSelect({ target }) {
    const label = qs(selectors.itemTrigger, target);
    const { parentNode: group, nextElementSibling: content } = label;

    if (label.dataset.expandByDefault === "false") {
      this._open(label, group, content);
    }
  },

  onBlockDeselect({ target }) {
    const label = qs(selectors.itemTrigger, target);
    const { parentNode: group, nextElementSibling: content } = label;

    if (label.dataset.expandByDefault === "false") {
      this._close(label, group, content);
    }
  },

  onUnload() {
    this.clickHandlers();
    this.animateCollapsibleRowList?.destroy();
  },
});
